module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion2"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin",
    class: _vm.tabs.tab1 ? 'tab-highlight' : ''
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion2",
      "href": "#detail2_1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES33UC4']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "detail2_1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC4']['180']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descCodinput),
      expression: "descCodinput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "coddesc_codinput",
      "name": "coddesc_codinput",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.descCodinput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descCodinput = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC4']['10']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descCodempid),
      expression: "descCodempid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "coddesc_codempid",
      "name": "coddesc_codempid",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.descCodempid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descCodempid = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC4']['20']))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "dtereq",
      "name": "dtereq",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.setDateOutput(_vm.detail.tab1.dtereq)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 box-panel-left"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "text-line-header"
  }, [_c('i', {
    staticClass: "fa fa-bank margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES33UC4']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC4']['50']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.adrcont1),
      expression: "detail.tab1.adrcont1"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab1.flg_adrcont1),
    attrs: {
      "type": "text",
      "id": "adrcont1",
      "name": "adrcont1",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab1.adrcont1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "adrcont1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC4']['60']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.desc_codsubdistr),
      expression: "detail.tab1.desc_codsubdistr"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab1.flg_desc_codsubdistr),
    attrs: {
      "type": "text",
      "id": "desc_codsubdistr",
      "name": "desc_codsubdistr",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab1.desc_codsubdistr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "desc_codsubdistr", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC4']['70']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.desc_coddistr),
      expression: "detail.tab1.desc_coddistr"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab1.flg_desc_coddistr),
    attrs: {
      "type": "text",
      "id": "desc_coddistr",
      "name": "desc_coddistr",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab1.desc_coddistr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "desc_coddistr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC4']['80']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.desc_codprovr),
      expression: "detail.tab1.desc_codprovr"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab1.flg_desc_codprovr),
    attrs: {
      "type": "text",
      "id": "desc_codprovr",
      "name": "desc_codprovr",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab1.desc_codprovr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "desc_codprovr", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC4']['90']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.desc_codcntyr),
      expression: "detail.tab1.desc_codcntyr"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab1.flg_desc_codcntyr),
    attrs: {
      "type": "text",
      "id": "desc_codcntyr",
      "name": "desc_codcntyr",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab1.desc_codcntyr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "desc_codcntyr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC4']['100']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.codpostr),
      expression: "detail.tab1.codpostr"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab1.flg_codpostr),
    attrs: {
      "type": "text",
      "id": "codpostr",
      "name": "codpostr",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab1.codpostr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "codpostr", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 box-panel-right"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "text-line-header"
  }, [_c('i', {
    staticClass: "fa fa-bank margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES33UC4']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC4']['110']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.adrcont2),
      expression: "detail.tab1.adrcont2"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab1.flg_adrcont2),
    attrs: {
      "type": "text",
      "id": "adrcont2",
      "name": "adrcont2",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab1.adrcont2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "adrcont2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC4']['120']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.desc_codsubdistc),
      expression: "detail.tab1.desc_codsubdistc"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab1.flg_desc_codsubdistc),
    attrs: {
      "type": "text",
      "id": "desc_codsubdistc",
      "name": "desc_codsubdistc",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab1.desc_codsubdistc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "desc_codsubdistc", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC4']['130']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.desc_coddistc),
      expression: "detail.tab1.desc_coddistc"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab1.flg_desc_coddistc),
    attrs: {
      "type": "text",
      "id": "desc_coddistc",
      "name": "desc_coddistc",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab1.desc_coddistc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "desc_coddistc", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC4']['140']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.desc_codprovc),
      expression: "detail.tab1.desc_codprovc"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab1.flg_desc_codprovc),
    attrs: {
      "type": "text",
      "id": "desc_codprovc",
      "name": "desc_codprovc",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab1.desc_codprovc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "desc_codprovc", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC4']['150']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.desc_codcntyc),
      expression: "detail.tab1.desc_codcntyc"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab1.flg_desc_codcntyc),
    attrs: {
      "type": "text",
      "id": "desc_codcntyc",
      "name": "desc_codcntyc",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab1.desc_codcntyc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "desc_codcntyc", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC4']['160']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.codpostc),
      expression: "detail.tab1.codpostc"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab1.flg_codpostc),
    attrs: {
      "type": "text",
      "id": "codpostc",
      "name": "codpostc",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab1.codpostc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "codpostc", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC4']['170']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.numtelec),
      expression: "detail.tab1.numtelec"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab1.flg_numtelec),
    attrs: {
      "type": "text",
      "id": "numtelec",
      "name": "numtelec",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab1.numtelec)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "numtelec", $event.target.value)
      }
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    class: _vm.tabs.tab2 ? 'tab-highlight' : ''
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion2",
      "href": "#detail2_2"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES33UC5']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "detail2_2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC5']['190']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descCodinput2),
      expression: "descCodinput2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "coddesc_codinput",
      "name": "coddesc_codinput",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.descCodinput2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descCodinput2 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC5']['10']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descCodempid2),
      expression: "descCodempid2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "coddesc_codempid",
      "name": "coddesc_codempid",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.descCodempid2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descCodempid2 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC5']['20']))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "dtereq",
      "name": "dtereq",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.setDateOutput(_vm.detail.tab2.dtereq)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 box-panel-left"
  }, [_c('div', {
    staticClass: "box-panel-center"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "text-line-header"
  }, [_c('i', {
    staticClass: "fa fa-credit-card-alt margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES33UC5']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC5']['40']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab2.numoffid),
      expression: "detail.tab2.numoffid"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab2.flg_numoffid),
    attrs: {
      "type": "text",
      "id": "numoffid",
      "name": "numoffid",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab2.numoffid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab2, "numoffid", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC5']['50']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab2.adrissue),
      expression: "detail.tab2.adrissue"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab2.flg_adrissue),
    attrs: {
      "type": "text",
      "id": "adrissue",
      "name": "adrissue",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab2.adrissue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab2, "adrissue", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC5']['60']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab2.desc_codprovi),
      expression: "detail.tab2.desc_codprovi"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab2.flg_desc_codprovi),
    attrs: {
      "type": "text",
      "id": "desc_codprovi",
      "name": "desc_codprovi",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab2.desc_codprovi)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab2, "desc_codprovi", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC5']['70']))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab2.flg_dteoffid),
    attrs: {
      "type": "text",
      "id": "dteoffid",
      "name": "dteoffid",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.setDateOutput(_vm.detail.tab2.dteoffid)
    }
  })])])])]), _vm._v(" "), _c('div', {}, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "text-line-header"
  }, [_c('i', {
    staticClass: "fa fa-credit-card-alt margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES33UC5']['75']))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC5']['80']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab2.numpasid),
      expression: "detail.tab2.numpasid"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab2.flg_numpasid),
    attrs: {
      "type": "text",
      "id": "numpasid",
      "name": "numpasid",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab2.numpasid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab2, "numpasid", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC5']['90']))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab2.flg_dtepasid),
    attrs: {
      "type": "text",
      "id": "dtepasid",
      "name": "dtepasid",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.setDateOutput(_vm.detail.tab2.dtepasid)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC5']['100']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab2.numprmid),
      expression: "detail.tab2.numprmid"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab2.flg_numprmid),
    attrs: {
      "type": "text",
      "id": "numprmid",
      "name": "numprmid",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab2.numprmid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab2, "numprmid", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC5']['110']))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab2.flg_dteprmst),
    attrs: {
      "type": "text",
      "id": "dteprmst",
      "name": "dteprmst",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.setDateOutput(_vm.detail.tab2.dteprmst)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC5']['120']))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab2.flg_dteprmen),
    attrs: {
      "type": "text",
      "id": "dteprmen",
      "name": "dteprmen",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.setDateOutput(_vm.detail.tab2.dteprmen)
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 box-panel-right"
  }, [_c('div', {
    staticClass: "box-panel-center"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "text-line-header"
  }, [_c('i', {
    staticClass: "fa fa-credit-card-alt margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES33UC5']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC5']['140']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab2.numlicid),
      expression: "detail.tab2.numlicid"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab2.flg_numlicid),
    attrs: {
      "type": "text",
      "id": "numlicid",
      "name": "numlicid",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab2.numlicid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab2, "numlicid", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-ms-6 col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC5']['150']))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab2.flg_dtelicid),
    attrs: {
      "type": "text",
      "id": "dtelicid",
      "name": "dtelicid",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.setDateOutput(_vm.detail.tab2.dtelicid)
    }
  })])])])]), _vm._v(" "), _c('div', {}, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "text-line-header"
  }, [_c('i', {
    staticClass: "fa fa-child margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES33UC5']['160']))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-ms-6 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC5']['170']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab2.desc_stamarry),
      expression: "detail.tab2.desc_stamarry"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab2.flg_desc_stamarry),
    attrs: {
      "type": "text",
      "id": "desc_stamarry",
      "name": "desc_stamarry",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab2.desc_stamarry)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab2, "desc_stamarry", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-ms-6 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC5']['180']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab2.desc_stamilit),
      expression: "detail.tab2.desc_stamilit"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab2.flg_desc_stamilit),
    attrs: {
      "type": "text",
      "id": "desc_stamilit",
      "name": "desc_stamilit",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab2.desc_stamilit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab2, "desc_stamilit", $event.target.value)
      }
    }
  })])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    class: _vm.tabs.tab3 ? 'tab-highlight' : ''
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion2",
      "href": "#detail2_3"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES33UC6']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "detail2_3"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC6']['230']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descCodinput3),
      expression: "descCodinput3"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "coddesc_codinput",
      "name": "coddesc_codinput",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.descCodinput3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descCodinput3 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC6']['10']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descCodempid3),
      expression: "descCodempid3"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "coddesc_codempid",
      "name": "coddesc_codempid",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.descCodempid3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descCodempid3 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC6']['20']))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "dtereq",
      "name": "dtereq",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.setDateOutput(_vm.detail.tab3.dtereq)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 box-panel-left"
  }, [_c('div', {
    staticClass: "box-panel-center"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "text-line-header"
  }, [_c('i', {
    staticClass: "fa fa-user-plus margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES33UC6']['0']))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC6']['40']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab3.namfathr),
      expression: "detail.tab3.namfathr"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab3.flg_namfathr),
    attrs: {
      "type": "text",
      "id": "namfathr",
      "name": "namfathr",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab3.namfathr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab3, "namfathr", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC6']['50']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab3.desc_codfnatn),
      expression: "detail.tab3.desc_codfnatn"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab3.flg_desc_codfnatn),
    attrs: {
      "type": "text",
      "id": "desc_codfnatn",
      "name": "desc_codfnatn",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab3.desc_codfnatn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab3, "desc_codfnatn", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC6']['60']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab3.desc_codfrelg),
      expression: "detail.tab3.desc_codfrelg"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab3.flg_desc_codfrelg),
    attrs: {
      "type": "text",
      "id": "desc_codfrelg",
      "name": "desc_codfrelg",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab3.desc_codfrelg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab3, "desc_codfrelg", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC6']['70']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab3.desc_codfoccu),
      expression: "detail.tab3.desc_codfoccu"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab3.flg_desc_codfoccu),
    attrs: {
      "type": "text",
      "id": "desc_codfoccu",
      "name": "desc_codfoccu",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab3.desc_codfoccu)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab3, "desc_codfoccu", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC6']['80']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab3.numofidf),
      expression: "detail.tab3.numofidf"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab3.flg_numofidf),
    attrs: {
      "type": "text",
      "id": "numofidf",
      "name": "numofidf",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab3.numofidf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab3, "numofidf", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {}, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "text-line-header"
  }, [_c('i', {
    staticClass: "fa fa-user-plus margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES33UC6']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC6']['100']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab3.nammothr),
      expression: "detail.tab3.nammothr"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab3.flg_nammothr),
    attrs: {
      "type": "text",
      "id": "nammothr",
      "name": "nammothr",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab3.nammothr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab3, "nammothr", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC6']['110']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab3.desc_codmnatn),
      expression: "detail.tab3.desc_codmnatn"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab3.flg_desc_codmnatn),
    attrs: {
      "type": "text",
      "id": "desc_codmnatn",
      "name": "desc_codmnatn",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab3.desc_codmnatn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab3, "desc_codmnatn", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC6']['120']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab3.desc_codmrelg),
      expression: "detail.tab3.desc_codmrelg"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab3.flg_desc_codmrelg),
    attrs: {
      "type": "text",
      "id": "desc_codmrelg",
      "name": "desc_codmrelg",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab3.desc_codmrelg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab3, "desc_codmrelg", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC6']['130']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab3.desc_codmoccu),
      expression: "detail.tab3.desc_codmoccu"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab3.flg_desc_codmoccu),
    attrs: {
      "type": "text",
      "id": "desc_codmoccu",
      "name": "desc_codmoccu",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab3.desc_codmoccu)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab3, "desc_codmoccu", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC6']['140']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab3.numofidm),
      expression: "detail.tab3.numofidm"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab3.flg_numofidm),
    attrs: {
      "type": "text",
      "id": "numofidm",
      "name": "numofidm",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab3.numofidm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab3, "numofidm", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 box-panel-right"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "text-line-header"
  }, [_c('i', {
    staticClass: "fa fa-user-plus margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES33UC6']['150']))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC6']['160']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab3.namcont),
      expression: "detail.tab3.namcont"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab3.flg_namcont),
    attrs: {
      "type": "text",
      "id": "namcont",
      "name": "namcont",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab3.namcont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab3, "namcont", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC6']['170']))]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab3.flg_adrcont1),
    attrs: {
      "id": "adrcont1",
      "name": "adrcont1",
      "maxlength": "600",
      "readonly": "readonly"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab3.adrcont1))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC6']['180']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab3.codpost),
      expression: "detail.tab3.codpost"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab3.flg_codpost),
    attrs: {
      "type": "text",
      "id": "codpost",
      "name": "codpost",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab3.codpost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab3, "codpost", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC6']['190']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab3.numtele),
      expression: "detail.tab3.numtele"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab3.flg_numtele),
    attrs: {
      "type": "text",
      "id": "numtele",
      "name": "numtele",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab3.numtele)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab3, "numtele", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC6']['200']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab3.numfax),
      expression: "detail.tab3.numfax"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab3.flg_numfax),
    attrs: {
      "type": "text",
      "id": "numfax",
      "name": "numfax",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab3.numfax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab3, "numfax", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC6']['210']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab3.email),
      expression: "detail.tab3.email"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab3.flg_email),
    attrs: {
      "type": "text",
      "id": "email",
      "name": "email",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab3.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab3, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC6']['220']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab3.desrelat),
      expression: "detail.tab3.desrelat"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab3.flg_desrelat),
    attrs: {
      "type": "text",
      "id": "desrelat",
      "name": "desrelat",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab3.desrelat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab3, "desrelat", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    class: _vm.tabs.tab4 ? 'tab-highlight' : ''
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion2",
      "href": "#detail2_4"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES33UC7']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "detail2_4"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC7']['150']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descCodinput),
      expression: "descCodinput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "coddesc_codinput",
      "name": "coddesc_codinput",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.descCodinput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descCodinput = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC7']['10']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descCodempid),
      expression: "descCodempid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "coddesc_codempid",
      "name": "coddesc_codempid",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.descCodempid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descCodempid = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC7']['20']))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "dtereq",
      "name": "dtereq",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.setDateOutput(_vm.detail.tab4.dtereq)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 box-panel-left"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "text-line-header"
  }, [_c('i', {
    staticClass: "fa fa-user-plus margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES33UC7']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC7']['51']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab4.namspous),
      expression: "detail.tab4.namspous"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab4.flg_namspous),
    attrs: {
      "type": "text",
      "id": "namspous",
      "name": "namspous",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab4.namspous)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab4, "namspous", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC7']['60']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab4.numoffid),
      expression: "detail.tab4.numoffid"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab4.flg_numoffid),
    attrs: {
      "type": "text",
      "id": "numoffid",
      "name": "numoffid",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab4.numoffid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab4, "numoffid", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC7']['70']))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab4.flg_dtespbd),
    attrs: {
      "type": "text",
      "id": "dtespbd",
      "name": "dtespbd",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.setDateOutput(_vm.detail.tab4.dtespbd)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC7']['80']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab4.desc_codspocc),
      expression: "detail.tab4.desc_codspocc"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab4.flg_desc_codspocc),
    attrs: {
      "type": "text",
      "id": "desc_codspocc",
      "name": "desc_codspocc",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab4.desc_codspocc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab4, "desc_codspocc", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC7']['90']))]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab4.flg_desnoffi),
    attrs: {
      "id": "desnoffi",
      "name": "desnoffi",
      "maxlength": "600",
      "readonly": "readonly"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab4.desnoffi) + "\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 box-panel-right"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "text-line-header"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES33UC7']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC7']['100']))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab4.flg_dtemarry),
    attrs: {
      "type": "text",
      "id": "dtemarry",
      "name": "dtemarry",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.setDateOutput(_vm.detail.tab4.dtemarry)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC7']['110']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab4.desplreg),
      expression: "detail.tab4.desplreg"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab4.flg_desplreg),
    attrs: {
      "type": "text",
      "id": "desplreg",
      "name": "desplreg",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab4.desplreg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab4, "desplreg", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC7']['120']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab4.desc_codsppro),
      expression: "detail.tab4.desc_codsppro"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab4.flg_desc_codsppro),
    attrs: {
      "type": "text",
      "id": "desc_codsppro",
      "name": "desc_codsppro",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab4.desc_codsppro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab4, "desc_codsppro", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC7']['130']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab4.desc_codspcty),
      expression: "detail.tab4.desc_codspcty"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab4.flg_desc_codspcty),
    attrs: {
      "type": "text",
      "id": "desc_codspcty",
      "name": "desc_codspcty",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab4.desc_codspcty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab4, "desc_codspcty", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC7']['140']))]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab4.flg_desnote),
    attrs: {
      "id": "desnote",
      "name": "desnote",
      "maxlength": "600",
      "readonly": "readonly"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab4.desnote) + "\n                  ")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    class: _vm.tabs.tab5 ? 'tab-highlight' : ''
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion2",
      "href": "#detail2_5"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES33UC8']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "detail2_5"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC8']['90']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descCodinput),
      expression: "descCodinput"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab1.flg_adrcont1),
    attrs: {
      "type": "text",
      "id": "coddesc_codinput",
      "name": "coddesc_codinput",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.descCodinput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descCodinput = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC8']['10']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descCodempid),
      expression: "descCodempid"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab1.flg_adrcont1),
    attrs: {
      "type": "text",
      "id": "coddesc_codempid",
      "name": "coddesc_codempid",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.descCodempid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descCodempid = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC8']['20']))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab1.flg_adrcont1),
    attrs: {
      "type": "text",
      "id": "dtereq",
      "name": "dtereq",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.setDateOutput(_vm.detail.tab5.dtereq)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 box-panel-left"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "text-line-header"
  }, [_c('i', {
    staticClass: "fa fa-bank margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES33UC15']['40']) + " 1")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC8']['30']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab5.desc_codbank),
      expression: "detail.tab5.desc_codbank"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab5.flg_desc_codbank),
    attrs: {
      "type": "text",
      "id": "desc_codbank",
      "name": "desc_codbank",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab5.desc_codbank)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab5, "desc_codbank", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC8']['40']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab5.numbank),
      expression: "detail.tab5.numbank"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab5.flg_numbank),
    attrs: {
      "type": "text",
      "id": "numbank",
      "name": "numbank",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab5.numbank)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab5, "numbank", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC8']['50']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab5.amtbank),
      expression: "detail.tab5.amtbank"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab5.flg_amtbank),
    attrs: {
      "type": "text",
      "id": "amtbank",
      "name": "amtbank",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab5.amtbank)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab5, "amtbank", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 box-panel-right"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "text-line-header"
  }, [_c('i', {
    staticClass: "fa fa-bank margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES33UC15']['40']) + " 2")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC8']['60']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab5.desc_codbank2),
      expression: "detail.tab5.desc_codbank2"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab5.flg_desc_codbank2),
    attrs: {
      "type": "text",
      "id": "desc_codbank2",
      "name": "desc_codbank2",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab5.desc_codbank2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab5, "desc_codbank2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC8']['70']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab5.numbank2),
      expression: "detail.tab5.numbank2"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab5.flg_numbank2),
    attrs: {
      "type": "text",
      "id": "numbank2",
      "name": "numbank2",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.tab5.numbank2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab5, "numbank2", $event.target.value)
      }
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    class: _vm.tabs.tab6 ? 'tab-highlight' : ''
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion2",
      "href": "#detail2_6"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES33UC9']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "detail2_6"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC9']['190']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descCodinput),
      expression: "descCodinput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "coddesc_codinput",
      "name": "coddesc_codinput",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.descCodinput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descCodinput = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC9']['10']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descCodempid),
      expression: "descCodempid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "coddesc_codempid",
      "name": "coddesc_codempid",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.descCodempid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descCodempid = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC9']['20']))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "dtereq",
      "name": "dtereq",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.setDateOutput(_vm.detail.tab6.detail.dtereq)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC9']['150']))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab6.detail.qtychedu),
      expression: "detail.tab6.detail.qtychedu"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab6.flg_qtychedu),
    attrs: {
      "type": "text",
      "id": "qtychedu",
      "name": "qtychedu"
    },
    domProps: {
      "value": (_vm.detail.tab6.detail.qtychedu)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab6.detail, "qtychedu", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES33UC9']['160']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC9']['170']))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab6.detail.qtychned),
      expression: "detail.tab6.detail.qtychned"
    }],
    staticClass: "form-control",
    class: _vm.checkHighlight(_vm.detail.tab6.flg_qtychned),
    attrs: {
      "type": "text",
      "id": "qtychned",
      "name": "qtychned"
    },
    domProps: {
      "value": (_vm.detail.tab6.detail.qtychned)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab6.detail, "qtychned", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES33UC9']['180']))])])])])])]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.tab2Tab6Table,
      "data": _vm.detail.tab6.table,
      "rowClassCondition": _vm.rowClassCondition
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    class: _vm.tabs.tab7 ? 'tab-highlight' : ''
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion2",
      "href": "#detail2_7"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES33UC15']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "detail2_7"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC15']['90']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descCodinput),
      expression: "descCodinput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "coddesc_codinput",
      "name": "coddesc_codinput",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.descCodinput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descCodinput = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC15']['10']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descCodempid),
      expression: "descCodempid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "coddesc_codempid",
      "name": "coddesc_codempid",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.descCodempid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descCodempid = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC15']['20']))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "dtereq",
      "name": "dtereq",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.setDateOutput(_vm.detail.tab7.detail.dtereq)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-header"
  }, [_vm._v(_vm._s(_vm.labels['HRES33UC15']['30']))]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.tab2Tab7Table,
      "data": _vm.detail.tab7.table,
      "rowClassCondition": _vm.rowClassCondition
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.buttonLabels['back']))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-76c30668!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres33u/detail2.vue
// module id = 3892
// module chunks = 1